import { CreateToastType } from 'blip-ds/dist/types/components/toast/toast-interface';

export const createToast = async (toast: CreateToastType) => {
    const timeOut = Math.max((toast.toastText?.length ?? 1) * 100, 5000) / 1000;
    toast.duration = timeOut;
    if (toast) {
        appendToast(toast);
    }
};

export const createToastSuccess = async (title: string, text: string) => {
    const timeOut = Math.max((text?.length ?? 1) * 100, 5000) / 1000;

    const toast: CreateToastType = {
        actionType: 'icon',
        icon: 'like',
        variant: 'success',
        toastTitle: title,
        toastText: text,
        position: 'bottom-left',
        duration: timeOut,
    };
    appendToast(toast);
};

export const createToastError = async (title: string, text: string) => {
    const timeOut = Math.max((text?.length ?? 1) * 100, 5000) / 1000;

    if (!!title && !!text) {
        const toast: CreateToastType = {
            actionType: 'icon',
            icon: 'error',
            variant: 'error',
            toastTitle: title ?? 'Erro',
            toastText: text,
            position: 'bottom-left',
            duration: timeOut,
        };
        appendToast(toast);
    }
};

export const createToastWarning = async (title: string, text: string) => {
    const timeOut = Math.max((text?.length ?? 1) * 100, 5000) / 1000;

    if (!!title && !!text) {
        const toast: CreateToastType = {
            actionType: 'icon',
            icon: 'warning',
            variant: 'warning',
            toastTitle: title ?? 'Aviso',
            toastText: text,
            position: 'bottom-left',
            duration: timeOut,
        };
        appendToast(toast);
    }
};

const appendToast = async (toast: CreateToastType) => {
    const newToast = document.createElement('bds-toast');
    document.body.appendChild(newToast);
    await newToast.create(toast);
};
